import React from "react";

const Chart = (props) => {

    function findMax(arr) {
        let max = arr[0].reports;

        for (let i = 1, len = arr.length; i < len; i++) {
            let v = arr[i].reports;
            max = (v > max)
                ? v
                : max;
        }
        return max;
    }


    // const row = props.data.filter(c => c.charttype === props.charttype).map((c, i) => (
    //     <tr key={i}>
    //         <td><a href={`#/schools/${c.ucls}`}>{c.school}</a></td>
    //         <td className="numsection">
    //             <span className="numberLabel">{c.chartnumber.toLocaleString()}{c.charttype === "water" && "%"}</span>
    //             <span className="chartBar" style={{
    //                 width: c.chartnumber / findMax(props.data.filter(c => c.charttype === props.charttype)) * 100 + "%"
    //             }}></span>
    //         </td>
    //     </tr>
    // ));

    const row = props.newdata.map((c,i) => (
        <tr key={i}>
            <td><a href={`#/schools/${c.ULCS}`}>{c.school}</a></td>
            <td className="numsection">
                <span className="numberLabel">{c.reports.toLocaleString()}{c.charttype === "water" && "%"}</span>
                <span className="chartBar" style={{
                    width: c.reports / findMax(props.newdata) * 100 + "%"
                }}></span>
            </td>
        </tr>
    ))

    return (
        <div className="chartRow">
            <div className="instructions"><i className="far fa-hand-pointer"></i> Select school to see reports</div>
            <table className={`TopicsChart ${props.charttype}`}>
                <tbody>
                    <tr>
                        <th>School</th>
                        <th>{props.chartlabel}</th>

                    </tr>
                    {row}
                </tbody>
            </table>

        </div>
    )
}

export default Chart



// WEBPACK FOOTER //
// ./src/components/Chart.js